module.exports = __webpack_public_path__ + "img/user-pict-placeholder.e58bdce2.png";